import { TpamsStrategyService } from "./tpams-strategy.service";
import { AflaModuleStrategyService } from "./afla-module-strategy.service";
import { ModuleConfigService } from "../module-config/module-config.service";
import { BpamsStrategyService } from "./bpams-strategy.service";
import { PlamsStrategyService } from "./plams-strategy.service";
import { WamsStrategyService } from "./wams-strategy.service";
import { CemeteryStrategyService } from "./cemetery-strategy.service";
import { PvStrategyService } from "./pv-strategy.service";
import { AamsStrategyService } from "./aams-strategy.service";
import { EhmsStrategyService } from "./ehms-strategy.service";
import { DamsStrategyService } from "./dams-strategy.service";
import { TmamsStrategyService } from "./tmams-strategy.service";
import { ZcamsStrategyService } from "./zcams-strategy.service";
import { EcStrategyService } from "./ec-strategy.service";
import { ItamsStrategyService } from "./itams-strategy.service";
import { RcStrategyService } from "./rc-strategy.service";
import { SnStrategyService } from "./sn-strategy.service";
import { BlStrategyService } from "./bl-strategy.service";
import { MndStrategyService } from "./mnd-strategy.service";
import { GtStrategyService } from "./gt-strategy.service";
export const aflaModuleStrategyServiceFactory = (moduleConfigService, tpamsStrategyService, bpamsStrategyService, plamsStrategyService, wamsStrategyService, cemeteryStrategyService, pvStrategyService, aamsStrategyService, ehmsStrategyService, ecStrategyService, damsStrategyService, tmamsStrategyService, zcamsStrategyService, itamsStrategyService, rcStrategyService, snStrategyService, blStrategyService, mndStrategyService, gtStrategyService) => {
    const currentSelectedModuleConfigName = moduleConfigService.getCurrentlySelectedModuleConfigName();
    switch (currentSelectedModuleConfigName) {
        case tpamsStrategyService.name: {
            return tpamsStrategyService;
        }
        case bpamsStrategyService.name: {
            return bpamsStrategyService;
        }
        case plamsStrategyService.name: {
            return plamsStrategyService;
        }
        case wamsStrategyService.name: {
            return wamsStrategyService;
        }
        case cemeteryStrategyService.name: {
            return cemeteryStrategyService;
        }
        case pvStrategyService.name: {
            return pvStrategyService;
        }
        case aamsStrategyService.name: {
            return aamsStrategyService;
        }
        case ehmsStrategyService.name: {
            return ehmsStrategyService;
        }
        case damsStrategyService.name: {
            return damsStrategyService;
        }
        case tmamsStrategyService.name: {
            return tmamsStrategyService;
        }
        case zcamsStrategyService.name: {
            return zcamsStrategyService;
        }
        case ecStrategyService.name: {
            return ecStrategyService;
        }
        case itamsStrategyService.name: {
            return itamsStrategyService;
        }
        case rcStrategyService.name: {
            return rcStrategyService;
        }
        case snStrategyService.name: {
            return snStrategyService;
        }
        case blStrategyService.name: {
            return blStrategyService;
        }
        case mndStrategyService.name: {
            return mndStrategyService;
        }
        case gtStrategyService.name: {
            return gtStrategyService;
        }
        default: {
            return null;
        }
    }
};
export const aflaModuleServiceProvider = {
    provide: AflaModuleStrategyService,
    useFactory: aflaModuleStrategyServiceFactory,
    deps: [
        ModuleConfigService,
        TpamsStrategyService,
        BpamsStrategyService,
        PlamsStrategyService,
        WamsStrategyService,
        CemeteryStrategyService,
        PvStrategyService,
        AamsStrategyService,
        EhmsStrategyService,
        EcStrategyService,
        DamsStrategyService,
        TmamsStrategyService,
        ZcamsStrategyService,
        ItamsStrategyService,
        RcStrategyService,
        SnStrategyService,
        BlStrategyService,
        MndStrategyService,
        GtStrategyService
    ]
};
